import React, { useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import { formatDatetime, formatEmail } from '../../../utils';
import ActionIcon from '../../../components/custom/ActionIcon';
import { ChangeEvent, IAttendanceUpdate } from '../../../globals/interfaces';
import { Input } from 'reactstrap';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    item: IAttendanceUpdate | undefined;
    addNotes: (notes: string) => Promise<void>;
}

export default function ModalNotes ({
    modal,
    setModal,
    item,
    addNotes
}: Props) {
    
    const [notes, setNotes] = useState('');
    const toggle = () => setModal(!modal);

    if (!item) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <FlexContainer>
                        <BackButton onClick={toggle} />
                        <h4 className={'pl-2'}>Detail</h4>
                    </FlexContainer>
                    <h4>Reason: {item.type}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <h6>Employee: {formatEmail(item.email)}</h6>
                <h6>Notes</h6>
                <Input type={'textarea'} value={notes} onChange={(e: ChangeEvent) => setNotes(e.target.value)} />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        Created by {formatEmail(item.email)} on {formatDatetime(item.created)}. Modifiedy by {formatEmail(item.modifiedBy)} on {formatDatetime(item.modified)}
                    </Label>
                    <FooterButtonsContainer>
                        <ActionIcon type={'save'} onClick={() => addNotes(notes)} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
`;